import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../../components/reduxFields';
import { GetReportUrl, base64Encode } from '../../../../../actions/utilAction';
import Loader from '../../../../../img/loader.gif';
import {getMasterData} from '../actions/index';

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

const validate = (values) => {
  const errors = {};
  
  if (!values.patientId) {
    errors.patientId = 'Please select client.';
  }
  if (!values.month) {
    errors.month = 'Please select month.';
  }
  if (!values.year) {
    errors.year = 'Please select year.';
  }
  
  return errors;
};

class EBSAuthorizationDetailsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //organizationID: this.props.orgID,
      access_token: this.props.access_token,
      MonthList: [{ id: 1, value: 'January' }, { id: 2, value: 'February' },{ id: 3, value: 'March' }, { id: 4, value: 'April' },{ id: 5, value: 'May' }, 
                  { id: 6, value: 'June' },{ id: 7, value: 'July' }, { id: 8, value: 'August' },{ id: 9, value: 'September' }, { id: 10, value: 'October' },
                  { id: 11, value: 'November' }, { id: 12, value: 'December' }],
      YearList: [{ id: 2017, value: '2017' }, { id: 2018, value: '2018' },{ id: 2019, value: '2019' },{ id: 2020, value: '2020' }, { id: 2021, value: '2021' },{ id: 2022, value: '2022' }, 
                  { id: 2023, value: '2023' },{ id: 2024, value: '2024' }, { id: 2025, value: '2025' },{ id: 2026, value: '2026' }, { id: 2027, value: '2027' },
                  { id: 2028, value: '2028' }, { id: 2029, value: '2029' }, { id: 2030, value: '2030' }],
      selectedMonth : 0,
      selectedYear : 0,     
      patientId : 0,       
      iframeURL: '',
      isLoading: false,
      random: 0,
      isIncludeExpiredAuth: false,
    };    
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.checkAuth = this.checkAuth.bind(this);
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTEREBSORGANIZATIONS',
    };   
    this.props.getMasterData(masterData);    
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe(); 
    let REPORT_URL  = GetReportUrl(this.props.agencyName);       
    let reportName = base64Encode('CL_WebadminAuthorizationDetails_RPT');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode((formData.OrganizationId || 0).toString()) + `"},{"Name": "IncludeExpiredAuth","Value": "` + this.state.isIncludeExpiredAuth + `"},{"Name": "Month","Value": "`+ this.state.selectedMonth + `"},{"Name": "Year","Value": "`+ this.state.selectedYear + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  } 

  checkAuth = (e, name) => {
    if (name === 'isIncludeExpiredAuth' && e.target.checked) {
      this.setState({isIncludeExpiredAuth : true});
    }
    else if (name === 'isIncludeExpiredAuth' && !e.target.checked) {
      this.setState({isIncludeExpiredAuth : false});
    } 
  }

  

  handleChange = (input, selectedRecord) => {   
    if (input.name === 'month') {
     this.setState({selectedMonth: selectedRecord.value});
    } else if (input.name === 'year') {
      this.setState({selectedYear: selectedRecord.value});
    }   
    
    input.onChange(selectedRecord.value);
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;    
    return (
      <div>
        {this.renderLoading()}
        <h2 className="page_title">Authorization Details Report</h2>                    
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="panel_title">
              <h7 style={styles.font}>*Scheduled and rendered hours use rounding rules in order to display actual hours remaining. </h7>                    
            </div>  
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-6 mt-35">
                    <Field name="OrganizationId"
                      label="Agency Name"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterEBSOrganizationsList}
                      component={renderAutoCompleteSingleSelect}
                    />
                </div>
                
                <div className="col-sm-4 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="isIncludeExpiredAuth"
                        label="Include Expired Authorizations"
                        onChange={(e) => this.checkAuth(e, 'isIncludeExpiredAuth')}
                        component={renderCheckBox}
                      />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field name="month"
                    label="Select Month"
                    handleNewRequest={this.handleChange}
                    options={this.state.MonthList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field name="year"
                    label="Select Year"
                    handleNewRequest={this.handleChange}
                    options={this.state.YearList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

EBSAuthorizationDetailsReport = reduxForm({
  form: 'EBSAuthorizationDetailsReportForm',
  validate,
  enableReinitialize: true,
})(EBSAuthorizationDetailsReport);

function mapStateToProps(state) {
  
// console.log('state.report.master_data............',state.report.master_data.allStaffs)
  return {
    //orgID: state.login.loginUserInfo.organizationID,
    masterEBSOrganizationsList : state.superadminReport.master_data ? state.superadminReport.master_data.masterEBSOrganizations : null,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {getMasterData})(EBSAuthorizationDetailsReport);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/Reports/components/EBSAuthorizationDetailsReport.js